import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/modal.module.scss';

const EmailCaptureModal = ({ isOpen, onClose, status }) => {
  if (!status) return null;

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <EmailModalContent status={status} />
    </Modal>
  );
};

export default EmailCaptureModal;

const EmailModalContent = ({ status }) => {
  let content;
  switch (status) {
    case 'success':
      content = {
        header: 'Welcome to Sunday!',
        body: `You're all set to grow something amazing. Watch your inbox for exclusive deals, expert tips, and the latest Sunday innovations to help create the yard of your dreams.`,
      };
      break;
    case 'email_already_exists':
      content = {
        header: `You're already part of the Sunday family!`,
        body: `No need to sign up again - you're already getting our best deals and expert advice. Keep an eye on your inbox for exclusive savings and tips to help your yard thrive.`,
      };
      break;
    default:
      content = { header: 'Welcome to Sunday!' };
  }

  return (
    <div className={styles.emailCaptureModal}>
      <h2>{content.header}</h2>
      {content.body && <p>{content.body}</p>}
    </div>
  );
};
